import { openPlaidConnectFlowModal } from "@components/PlaidConnectFlow/openPlaidConnectFlowModal";
import { buildPortfolioUploadHoldingsChatQuestion } from "@components/PlaidImportModal/portfolioUploadHoldingsChatQuestion";
import type { SenderAttachment } from "@components/Sender/type";

/**
 * EDG-591 Chat `+` 菜单上传项：不过付费墙，直达 V3.0.6 上传页（P5）；
 * Confirm 后由调用方在**当前会话**发出 portfolio_upload 协议行 + 附件。
 */
export const openComposerMenuUpload = (
  send: (question: string, attachments: SenderAttachment[]) => void,
): Promise<void> =>
  openPlaidConnectFlowModal({
    startManualUpload: true,
    from: "composer_menu",
    onUploadSuccess: (attachments) => {
      send(buildPortfolioUploadHoldingsChatQuestion(), attachments);
    },
  });
